// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\TransactionTotalsPosDetailResponse

export type TransactionTotalsPosDetailApiResponse = {
	key: string;
	amount: number;
	count: number;
};

export type TransactionTotalsPosDetail = {
	key: string;
	amount: number;
	count: number;
};

export function hydrateTransactionTotalsPosDetail(data: TransactionTotalsPosDetailApiResponse): TransactionTotalsPosDetail {
	return { ...data };
}